<div class="flex justify-end items-center flex-nowrap gap-2">
<nz-page-header-extra>
  <nz-space>
    <nz-input-group class="mr-1" [nzPrefix]="searchIcon">
      <input nz-input class="w-full" type="search" [(ngModel)]="searchText" placeholder="Search here..."
        (ngModelChange)="getSearchDetails(searchText)">
    </nz-input-group>
    <ng-template #searchIcon>
      <span nz-icon nzType="search" aria-hidden="true"></span>
    </ng-template>
    <button nz-button class="mr-1" nzType="default" type="button" [nzTooltipColor]="'#fff'" nz-tooltip
      nzTooltipTitle="Refresh" [nzShape]="'circle'" (click)="refreshHandler()">
      <i nz-icon nzType="reload"></i>
    </button>
    <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="isVisible = true"><i nz-icon
        nzType="plus"></i>Add Excel</button>
            <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="downloadTemplate()"><i nz-icon
                nzType="plus"></i>Download Template</button>
  </nz-space>
</nz-page-header-extra>
</div>

<nz-table #nzTable #assetSensorMappingList nzShowSizeChanger [nzLoading]="isLoading"
[nzScroll]="{ x: '1024px', y: '35dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'"
[nzShowTotal]="totalTemplate"  [nzData]="filteredAssetSensorMappingList$">
  <thead>
    <tr>
      <th nzWidth="50%">Asset ID</th>
      <th nzWidth="50%">Asset Name</th>
      <th nzWidth="50%">Cold Spot Device EUI</th>
      <th nzWidth="50%">Hot Spot Device EUI</th>
      <th nzWidth="50%">Neither</th>
      <th nzWidth="50%">Last Updated User</th>
      <th nzWidth="50%">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let asm of assetSensorMappingList.data; let i = index; trackBy: commonService.trackByFn">
      <td>{{asm.assetId}}</td>
      <td>{{asm.assetName}}</td>
      <td>{{asm.ColdSpotDevEUI}}</td>
      <td>{{asm.HotSpotDevEUI}}</td>
      <td>{{asm.NeitherDevEUI}}</td>
      <td>{{asm.lastUpdateUser}}</td>
      <td>
      <span nz-tooltip="Delete" nz-icon nzType="delete" nzTheme="outline" class="text-base text-danger cursor-pointer ml-5"
        nz-popconfirm nzPopconfirmPlacement="bottom" nzPopconfirmTitle="Are you sure to remove this record?"
        (nzOnConfirm)="deleteAssetSensorMapping(asm)" [nzTooltipColor]="'#fff'"></span>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" (nzOnCancel)="isVisible = false">
  <ng-template #modalTitle>
    <div class="flex justify-between items-center">
      <span>Add Excel</span>
      <a *ngIf="excelErrLink" (click)="downloadLogFile()"
        class="text-blue-600 pt-10 font-bold cursor-pointer hover:underline">
        <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
        Download Log
      </a>
    </div>
  </ng-template>

  <ng-template #excelContent>
    <ng-container>
      <div *ngIf="excelErr && !isSuccessMessage" class="mb-4 p-3 bg-red-50 text-red-700 border border-red-200 rounded">
        <strong>Error:</strong> {{ excelErr }}
      </div>

      <!-- Success Message -->
      <div *ngIf="excelErr && isSuccessMessage"
        class="mb-4 p-3 bg-green-50 text-green-700 border border-green-200 rounded">
        <strong>Success:</strong> {{ excelErr }}
      </div>
      <ng-container>
        <div class="upload-container">
          <label for="excelFile" class="custom-file-upload">
            <span> <i nz-icon nzType="upload" nzTheme="outline" class="text-primary text-[30px]"></i></span>
            <input #addAssetFile type="file" id="excelFile" (change)="onFileChange($event)" accept=".xls,.xlsx">
            <p class="ant-upload-text">Click or drag file to this area to upload</p>
            <p class="ant-upload-hint">File headers should match, and all fields must have appropriate data.</p>
          </label>
        </div>
        <div class="uploaded-files" *ngIf="fileList.length > 0">
          <div class="uploaded-file flex items-center justify-between mb-2">
            <i nz-icon [nzType]="fileList[0].name.toLowerCase().endsWith('.xlsx') ? 'file-excel' : 'file-excel'"
              nzTheme="twotone" class="mr-2"></i>
            <span class="filename flex-1">{{ fileList[0].name }}</span>
            <span class="filesize text-sm text-gray-600">
              ({{ (fileList[0].size / 1024 / 1024).toFixed(2) }} MB)
            </span>
            <button type="button" nzType="link" (click)="removeFile()">
              <i nz-icon nzType="delete"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #excelFooter>
    <div class="flex justify-end">
      <button nz-button nzType="default" (click)="isVisible = false">Cancel</button>
      <button nz-button nzType="primary" (click)="onExcelSubmit()" [nzLoading]="isLoading">Submit</button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="excelContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="excelFooter"></ng-container>
  </ng-container>
</nz-modal>

  <ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>
